// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { ILevelDomainDto } from 'src/app/infrastructure/models/level-domain-dto';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { IDomainUserData, domainUserData } from 'src/app/features/domain-user/models/domain-user-data';
import { IDomainDto } from './domain-dto.g';
import { IImageBoxDto } from './image-box-dto.g';
import { IMembershipLockEnumDto } from './membership-lock-enum-dto.g';
import { IUserDto } from './user-dto.g';
import { IAffiliationEnumDto } from './affiliation-enum-dto.g';

export const domainUserDto = {
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    isAdmin: 'isAdmin',
    isOwner: 'isOwner',
    startDate: 'startDate',
    endDate: 'endDate',
    startDay: 'startDay',
    endDay: 'endDay',
    timeZoneId: 'timeZoneId',
    lastVisit: 'lastVisit',
    affiliation: 'affiliation',
    organisationContact_Guid: 'organisationContact_Guid',
    organisation_Name: 'organisation_Name',
    deleted: 'deleted',
    inactive: 'inactive',
    permanent: 'permanent',
    guestEndAuto: 'guestEndAuto',
    twoFactorRequiredFrom: 'twoFactorRequiredFrom',
    endDateLock: 'endDateLock',
    domainDto: 'domainDto',
    userDto: 'userDto',
    domainPhotoDto: 'domainPhotoDto',
    profilePhotoDto: 'profilePhotoDto',
    userPhotoDto: 'userPhotoDto',
} as const;

export type TDomainUserDto = (typeof domainUserDto)[keyof typeof domainUserDto];

export const domainUserDtoConstraints = {
    userGuid: { required: true },
} as const;

export type TDomainUserDtoConstraints = typeof domainUserDtoConstraints;

export interface IDomainUserDto extends ILevelDomainDto {
    [domainUserDto.guid]: string | null;
    [domainUserDto.nr]: number | null;
    [domainUserDto.name]: string | null;
    [domainUserDto.isAdmin]: boolean | null;
    [domainUserDto.isOwner]: boolean | null;
    [domainUserDto.startDate]: string | null;
    [domainUserDto.endDate]: string | null;
    [domainUserDto.startDay]: string | null;
    [domainUserDto.endDay]: string | null;
    [domainUserDto.timeZoneId]: string | null;
    [domainUserDto.lastVisit]: string | null;
    [domainUserDto.affiliation]: IAffiliationEnumDto | null;
    [domainUserDto.organisationContact_Guid]: string | null;
    [domainUserDto.organisation_Name]: string | null;
    [domainUserDto.deleted]: boolean | null;
    [domainUserDto.inactive]: boolean | null;
    [domainUserDto.permanent]: boolean | null;
    [domainUserDto.guestEndAuto]: boolean | null;
    [domainUserDto.twoFactorRequiredFrom]: string | null;
    [domainUserDto.endDateLock]: IMembershipLockEnumDto | null;
    [domainUserDto.domainDto]: IDomainDto | null;
    [domainUserDto.userDto]: IUserDto | null;
    [domainUserDto.domainPhotoDto]: IImageBoxDto | null;
    [domainUserDto.profilePhotoDto]: IImageBoxDto | null;
    [domainUserDto.userPhotoDto]: IImageBoxDto | null;
}

export class DomainUserDto
    implements IDomainUserDto
{
    [domainUserDto.guid]: string | null = null;
    [domainUserDto.nr]: number | null = null;
    [domainUserDto.name]: string | null = null;
    [domainUserDto.isAdmin]: boolean | null = null;
    [domainUserDto.isOwner]: boolean | null = null;
    [domainUserDto.startDate]: string | null = null;
    [domainUserDto.endDate]: string | null = null;
    [domainUserDto.startDay]: string | null = null;
    [domainUserDto.endDay]: string | null = null;
    [domainUserDto.timeZoneId]: string | null = null;
    [domainUserDto.lastVisit]: string | null = null;
    [domainUserDto.affiliation]: IAffiliationEnumDto | null = null;
    [domainUserDto.organisationContact_Guid]: string | null = null;
    [domainUserDto.organisation_Name]: string | null = null;
    [domainUserDto.deleted]: boolean | null = null;
    [domainUserDto.inactive]: boolean | null = null;
    [domainUserDto.permanent]: boolean | null = null;
    [domainUserDto.guestEndAuto]: boolean | null = null;
    [domainUserDto.twoFactorRequiredFrom]: string | null = null;
    [domainUserDto.endDateLock]: IMembershipLockEnumDto | null = null;
    [domainUserDto.domainDto]: IDomainDto | null = null;
    [domainUserDto.userDto]: IUserDto | null = null;
    [domainUserDto.domainPhotoDto]: IImageBoxDto | null = null;
    [domainUserDto.profilePhotoDto]: IImageBoxDto | null = null;
    [domainUserDto.userPhotoDto]: IImageBoxDto | null = null;

    private constructor(
        modelData?: IDomainUserData
    ) {
        if (!modelData || isEmptyObject(modelData)) return;

        this[domainUserDto.guid] = modelData[domainUserData.guid] ?? null;
        this[domainUserDto.nr] = modelData[domainUserData.nr] ?? null;
        this[domainUserDto.name] = modelData[domainUserData.name] ?? null;
        this[domainUserDto.isAdmin] = modelData[domainUserData.isAdmin] ?? null;
        this[domainUserDto.isOwner] = modelData[domainUserData.isOwner] ?? null;
        this[domainUserDto.deleted] = modelData[domainUserData.deleted] ?? null;
        this[domainUserDto.inactive] = modelData[domainUserData.inactive] ?? null;
    }

    static create(modelData?: IDomainUserData | null): IDomainUserDto | null {
        return modelData ? new DomainUserDto(modelData) : null;
    }
}
